window.addEventListener('SITE_START', () => {
  const triggers = document.querySelectorAll('.popup-trigger');
  const closeTriggers = document.querySelectorAll('[data-popup-close]');
  let activePopup = null;

  // Lenis 인스턴스 (전역 선언된 lenis를 가져옴)
  const lenis = window.lenis;

  // 팝업 열기
  triggers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const targetSelector = btn.dataset.popupTarget;
      const $popup = document.getElementById(targetSelector);
      if (!$popup) return;

      const $scrollableArea = $popup.querySelector('[data-popup-scrollable]');
      const $layer = $popup.querySelector('.__layer');
      const $scrollArea = $scrollableArea || $popup.querySelector('.__body');

      activePopup = $popup;

      // Lenis 정지 → 배경 스크롤 잠금
      if (lenis) lenis.stop();

      $popup.classList.add('is-open');
      $popup.setAttribute('aria-hidden', 'false');

      gsap.set($popup, { opacity: 0 });
      gsap.set($layer, { opacity: 0, y: 20 });

      gsap
        .timeline()
        .to($popup, { opacity: 1, duration: 0.3, ease: 'power2.out' })
        .to($layer, { opacity: 1, y: 0, duration: 0.3, ease: 'power2.out' }, '-=0.1');

      // 팝업 내부만 스크롤 가능하도록 이벤트 제어
      if ($scrollArea) {
        $scrollArea.addEventListener('wheel', (e) => e.stopPropagation());
        $scrollArea.addEventListener('touchmove', (e) => e.stopPropagation());
      }
    });
  });

  // 팝업 닫기
  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      const $popup = e.target.closest('.popup');
      if (!$popup) return;
      closePopup($popup);
    });
  });

  // ESC 키로 닫기
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && activePopup) {
      closePopup(activePopup);
    }
  });

  // 닫기 함수
  function closePopup($popup) {
    const $layer = $popup.querySelector('.__layer');

    gsap
      .timeline({
        onComplete: () => {
          $popup.classList.remove('is-open');
          $popup.setAttribute('aria-hidden', 'true');
          activePopup = null;
          if (lenis) lenis.start(); // Lenis 복원
        },
      })
      .to($layer, { opacity: 0, y: 20, duration: 0.25, ease: 'power2.in' })
      .to($popup, { opacity: 0, duration: 0.25, ease: 'power2.in' }, '-=0.1');
  }
});
